import { useEffect, useState } from 'react';
import LoadingSpinner from '../../../components/LoadingSpinner';
import WelcomeLine from '../../../components/WelcomeLine';
import { useDict } from '../../../contexts/LanguageContext';
import { getSummaryInvestmentData } from '../src/profileApis';
import { useProfileQuery } from '../src/profileQueries';
import ListProfile from './ListProfile';
import ProfileDashboard from './ProfileDashboard';

const Profile = () => {
    const dict = useDict();

    const [isFetching, setIsFetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [summaryInvestmentData, setSummaryInvestmentData] = useState([]);

    const { data: profileData } = useProfileQuery();

    useEffect(() => {
        setIsFetching(true);

        window.scrollTo(0, 0);

        getUserSummaryInvestmentData();

        setIsFetching(false);
    }, []);

    const handleGetSummaryInvestmentData = (response) => {
        setSummaryInvestmentData(response.data.data);
    };

    const getUserSummaryInvestmentData = () => {
        getSummaryInvestmentData(handleGetSummaryInvestmentData);
    };

    return (
        <div className="page-wrapper">
            {isLoading && <LoadingSpinner />}
            <div className="dashboard-section container">
                <WelcomeLine name={profileData?.first_name || 'N/A'} />
                <div className="myProfile__summary-container">
                    <ProfileDashboard
                        readableWalletId={
                            profileData?.wallets?.[0]?.readable_wallet_id || '-'
                        }
                        summaryData={summaryInvestmentData}
                        // countCurrentIssuer={
                        //     summaryInvestmentData?.count_current_issuer || '-'
                        // }
                        // countCurrentNote={
                        //     summaryInvestmentData?.count_current_note || '-'
                        // }
                        // countInvestedNote={
                        //     summaryInvestmentData?.count_invested_note || '-'
                        // }
                        // highestInvestmentMade={
                        //     summaryInvestmentData?.highest_investment_made
                        //         ? parseFloat(
                        //             summaryInvestmentData.highest_investment_made
                        //         ).toFixed(2)
                        //         : '-'
                        // }
                        // totalInvestmentAmount={
                        //     summaryInvestmentData?.total_investment_amount
                        //         ? parseFloat(
                        //             summaryInvestmentData.total_investment_amount
                        //         ).toFixed(2)
                        //         : '-'
                        // }
                        isFetching={isFetching}
                    />
                </div>
            </div>
            <div className="container" style={{ display: 'grid' }}>
                <ListProfile
                    profileData={profileData}
                    isFetching={isFetching}
                    setIsLoading={setIsLoading}
                />
            </div>
        </div>
    );
};

export default Profile;
